// extracted by mini-css-extract-plugin
export default {"resultPage":"Page_resultPage__CLCZE","jobDetailsContainer":"Page_jobDetailsContainer__SetXJ","resultSidebar":"Page_resultSidebar__0-Zxu","invited":"Page_invited__7WnwE"};